// Confetti celebration utility
import confetti from 'canvas-confetti';

// Default confetti for habit completion
export const triggerHabitComplete = () => {
  confetti({
    particleCount: 50,
    spread: 60,
    origin: { y: 0.7 },
    colors: ['#3B82F6', '#8B5CF6', '#EC4899', '#10B981', '#F59E0B'],
  });
};

// Bigger celebration for streaks
export const triggerStreakMilestone = (streakCount) => {
  const duration = 2000;
  const animationEnd = Date.now() + duration;

  const colors = ['#3B82F6', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981'];

  const frame = () => {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colors,
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colors,
    });

    if (Date.now() < animationEnd) {
      requestAnimationFrame(frame);
    }
  };

  frame();
};

// Grand celebration for milestone achievements (25%, 50%, 75%, 100%)
export const triggerMilestoneAchieved = (level) => {
  const count = level === 'perfect' ? 200 : level === 'gold' ? 150 : level === 'silver' ? 100 : 60;
  
  const defaults = {
    origin: { y: 0.7 },
    zIndex: 9999,
  };

  function fire(particleRatio, opts) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    });
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
    colors: ['#FFD700', '#FFA500', '#FF6347'],
  });
  fire(0.2, {
    spread: 60,
    colors: ['#3B82F6', '#8B5CF6', '#EC4899'],
  });
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
    colors: ['#10B981', '#06B6D4', '#6366F1'],
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
    colors: ['#F59E0B', '#EF4444', '#8B5CF6'],
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 45,
    colors: ['#EC4899', '#14B8A6', '#F97316'],
  });
};

// Emoji burst for completing all habits in a day
export const triggerAllHabitsComplete = () => {
  const scalar = 2;
  const unicorn = confetti.shapeFromText({ text: '🎉', scalar });
  const star = confetti.shapeFromText({ text: '⭐', scalar });
  const fire = confetti.shapeFromText({ text: '🔥', scalar });

  const defaults = {
    spread: 360,
    ticks: 60,
    gravity: 0.5,
    decay: 0.96,
    startVelocity: 20,
    shapes: [unicorn, star, fire],
    scalar,
  };

  confetti({
    ...defaults,
    particleCount: 30,
  });

  confetti({
    ...defaults,
    particleCount: 15,
    scalar: scalar / 2,
    shapes: ['circle'],
    colors: ['#FFD700', '#FFA500'],
  });
};
